import React, {useState, useEffect} from "react";
import {Modal, ModalBody, ModalHeader, ModalFooter} from "reactstrap";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {requestUserList} from "../../redux/Actions/group.action";
import {handoffAlert, handoffSensorAlert} from "../../redux/Actions/alerts.actions";
import {getUsersList} from "../../redux/Selectors/group.selector";
import {useFetchAlerts} from "../../views/Alerts/alertsTable/useAlertTableData";
import {useFetchSensorAlerts} from "../../views/SensorAlerts/sensorAlertsTable/useSensorAlertTableData";
import ZeusButton from "../Button";
import Loader from "../Loader";
import SelectCreator from "../Forms/components/SelectCreator";

const AlertHandoff = (props) => {
  const {alertId, onCancel, open, type = "system"} = props;
  const dispatch = useDispatch();
  const {refetch} = useFetchAlerts();
  const {refetch: refetchSensorAlerts} = useFetchSensorAlerts();
  const [users, setUsers] = useState([]);
  const user_list = useSelector(getUsersList);

  useEffect(() => {
    dispatch(requestUserList(true));
  }, [dispatch]);

  const handleSubmit = () => {
    const refetchFunction = {
      system: refetch,
      sensor: refetchSensorAlerts,
    };
    const handoffAction = {
      system: handoffAlert,
      sensor: handoffSensorAlert,
    };
    const callback = () => {
      onCancel();
      refetchFunction[type]();
    };
    dispatch(handoffAction[type]({alert: alertId, users}, callback));
  };

  return (
    <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"md"}>
      <Loader />
      <ModalHeader>Alert Handoff</ModalHeader>
      <ModalBody>
        <div className="ml--3 mr--3">
          <SelectCreator
            label={"USER"}
            options={user_list}
            value={users}
            onChange={(e) => setUsers(e.target.value)}
            classNamePrefix={"select_user"}
            id={"select_user"}
            large
            isMulti
          />
          <ModalFooter>
            <ZeusButton data-cy="submit-btn" onClick={handleSubmit}>
              SUBMIT
            </ZeusButton>
            <ZeusButton onClick={onCancel} data-cy={"cancel-btn"} className="info-small">
              CANCEL
            </ZeusButton>
          </ModalFooter>
        </div>
      </ModalBody>
    </Modal>
  );
};

AlertHandoff.propTypes = {
  alertId: PropTypes.number,
  onCancel: PropTypes.func,
  open: PropTypes.bool,
  type: PropTypes.oneOf(["system", "sensor"]),
};
export default AlertHandoff;
